import { Box, Container, Typography } from "@mui/material";
import React, { useContext } from "react";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { OfertasContext } from "../../../context/ofertas/OfertasContext";
import ProductCard from "../../../components/ProductCard/ProductCard";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { AuthContext } from "../../../context/authContext";
import logoDefault from "../../../images/productDefault.jpg";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";

export const Ofertas = () => {
  const { data }         = useContext(OfertasContext);
  const { empresa = {} } = useContext(AuthContext);

  const getImageSrc = (p) => {
    const a = p?.art_imagen?.trim();
    const e = empresa?.imagen_articulo?.trim();
    if (a) return `${process.env.REACT_APP_URL_BACKEND}${a}`;
    if (e) return `${process.env.REACT_APP_URL_BACKEND}${e}`;
    return logoDefault;
  };
  
  const products = data?.ofertas_det?.map((item, index) => {
    const p   = item?.oferta_Art;
    const pN  = item?.aofd_art_nprecio  ?? 0;
    const pO  = item?.aofd_ofertaprecio ?? 0;
    const stock = item?.stock ?? 0;
    const sf  = stock.toLocaleString("es-AR", { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true });
    const hayOferta = pN !== pO;
    const pct = pN > 0
      ? (((pN - pO) / pN) * 100).toLocaleString("es-AR", { minimumFractionDigits: 0, maximumFractionDigits: 0 })
      : null;

    const installment =  (stock > 0 ? (hayOferta ? `Oferta: ${sf} u` : `Disponible: ${sf} u`) : "Sin Stock");

    const fp = "$" + pO.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const fo = pN ? "$" + pN.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : null;
    const iu = p?.art_imagen?.trim()
      ? `${process.env.REACT_APP_URL_BACKEND}${p.art_imagen}`
      : `${process.env.REACT_APP_URL_BACKEND}${empresa?.imagen_articulo}`;

    return {
      id: p?.id?.toString() || index.toString(),
      code: p?.art_codigo,
      category: p?.Ramo?.descripcion_ramo,
      description: p?.art_descripcion,
      title: p?.art_descripcion,
      price: fp, precioMostrar: fp, priceOld: fo,
      percentage: pct, stockActual: sf, installment,
      section: "TrendingProducts",
      imgSrc: getImageSrc(p),
      urls: [iu],
    };
  }) || [];

  if (!products.length) return null;

  return (
    <Container maxWidth={false} sx={{ maxWidth: "var(--container-max)", px: { xs: 1.5, md: 3 }, py: { xs: 1.5, md: 2 } }}>

      {/* ── Header compacto ── */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mb: { xs: 1.5, md: 2 } }}>
        <Box sx={{
          width: 34, height: 34, borderRadius: "9px",
          bgcolor: "var(--accent-soft)",
          display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
        }}>
          <LocalOfferOutlinedIcon sx={{ color: "var(--accent)", fontSize: 18 }} />
        </Box>
        <Box>
          <Typography sx={{
            fontFamily: "var(--font-heading)", fontWeight: 800,
            fontSize: { xs: "1.05rem", md: "1.2rem" },
            color: "var(--text-primary)", letterSpacing: "-0.02em", lineHeight: 1.1,
          }}>
            Ofertas
          </Typography>
          <Typography sx={{ fontFamily: "var(--font-body)", fontSize: "0.72rem", color: "var(--text-muted)" }}>
            Los mejores precios del momento
          </Typography>
        </Box>
      </Box>

      {/* ── Slider ── */}
      <Swiper
        navigation
        pagination={{ clickable: true }}
        breakpoints={{
          0:    { slidesPerView: 2,   spaceBetween: 8  },
          480:  { slidesPerView: 2.5, spaceBetween: 10 },
          640:  { slidesPerView: 3,   spaceBetween: 12 },
          900:  { slidesPerView: 4,   spaceBetween: 14 },
          1200: { slidesPerView: 5,   spaceBetween: 16 },
          1600: { slidesPerView: 6,   spaceBetween: 16 },
        }}
        modules={[Pagination, Navigation]}
        style={{ paddingBottom: "36px" }}
      >
        {products
          .filter(i => i.section === "TrendingProducts")
          .map(item => (
            <SwiperSlide key={item.id} style={{ height: "auto" }}>
              <ProductCard data={item} />
            </SwiperSlide>
          ))
        }
      </Swiper>

    </Container>
  );
};

export default Ofertas;